import { useEffect } from "react";
import { useCurrentTenant } from "@/hooks/useTenant";
import { applyTenantTheme } from "@/lib/theme";

/**
 * Side-effect hook — fetches the broker tenant for the current subdomain
 * and injects its primary color onto `:root` so every component using
 * the `--primary` CSS variable picks it up. Reverts to the default
 * theme on platform-admin (no subdomain) or when the tenant has no
 * custom color.
 *
 * Mount once at the app root.
 */
export function useTenantTheme() {
  const { data } = useCurrentTenant();
  useEffect(() => {
    applyTenantTheme(data?.tenant?.primaryColor ?? null);
  }, [data?.tenant?.primaryColor]);
}
